import { isClientDebugEnabled } from '@/core/clientLogger';

function isRveStickerPreviewOverlayLog(args: unknown[]): boolean {
  if (args.length < 2 || args[0] !== 'overlay' || typeof args[1] !== 'object' || args[1] === null) {
    return false;
  }
  return (args[1] as { id?: string }).id === 'preview';
}

/**
 * Suppresses RVE SDK debug `console.log("overlay", …)` from sticker grid previews.
 *
 * Other SDK logs are forwarded only when ``VITE_DEBUG`` is enabled.
 *
 * @returns Restore `console.log` when the Neo editor unmounts.
 */
export function suppressRveStickerPreviewLogs(): () => void {
  const original = console.log;
  console.log = (...args: unknown[]) => {
    if (isRveStickerPreviewOverlayLog(args)) {
      return;
    }
    if (isClientDebugEnabled()) {
      original.apply(console, args);
    }
  };
  return () => {
    console.log = original;
  };
}
